import * as React from "react";

import "./my-profile-route.scss";

import {ComponentLink, Link, makeChain} from "@Common/react/cst2";
import {Load2}                          from "@Common/react/load2";
import {Types}                          from "@Common/types";

import {consumeContext} from "@Xpresso/loaders/consume-context";
import {InternalLink}   from "@Xpresso/routes/common/components/internal-link";
import {COMPANY_LEVEL}  from "@Xpresso/routes/common/logic/user-level";

import {AccountTabsLayout}      from "../common/account-tabs-layout/account-tabs-layout";
import {PasswordUpdateModal}    from "../common/password-update-modal/password-update-modal";
import {SecurityQuestionModal}  from "../common/security-question-modal/security-question-modal";
import {UserNameEdit}           from "../common/user-name-edit/user-name-edit";

export const AccountMyProfileRoute = () => (
    makeChain<JSX.Element>()
    .then(...consumeContext("accountMenu"))
    .then(...consumeContext("apis"))
    .then(...consumeContext("userLevels"))
    .then(({accountMenu}, next:Link<JSX.Element>) => AccountTabsLayout({
        activeMenu: "myProfile",
        activeTab: "my-profile",
        config: accountMenu?.myProfileMenu?.subMenu ?? [],
        next,
    }))
    .then("genericUserExists", ({userLevels}, next:ComponentLink<typeof checkGenericUserExists>) => (
        checkGenericUserExists({next, userLevels})
    ))
    .then("user", ({apis}, next:ComponentLink<typeof Load2<Types.Apis.Payloads.Next.UserProfile.GetUser.Response>>) => (
        Load2({fetch: apis.next.userProfile.getUserProfile, next})
    ))
    .then("managePasswordModal", ({apis}, next:ComponentLink<typeof PasswordUpdateModal>) => PasswordUpdateModal({
        next,
        title: "Password",
        onSave: apis.next.userProfile.updateUserProfile,
        urlParam: "password"
    }))
    .then("securityQuestionModal", ({apis}, next:ComponentLink<typeof SecurityQuestionModal>) => SecurityQuestionModal({
        next,
        title: "Security Questions",
        onSave: apis.next.userProfile.updateUserProfile,
        urlParam: "questions"
    }))
    .then(({genericUserExists, managePasswordModal, securityQuestionModal, user, userLevels}) => (
        <div className="my-profile-7f579716">
            <UserNameEdit user={user}/>
            <div className="line"/>

            <section>
                <header>
                    <div className="title" xd-qa-type="label" xd-qa-name="Password">Password</div>
                    <button className="edit" onClick={managePasswordModal.show} xd-qa-type="link" xd-qa-name="Edit Password">Edit</button>
                </header>
                {genericUserExists && (
                    <div className="sub-title" xd-qa-type="label" xd-qa-name="Profile Password Helper Text">
                        Reset password for your personal account. To update this shared
                        {userLevels.userLevel === COMPANY_LEVEL ? " company " : " office "}
                        account's password,&nbsp;
                        <InternalLink to="/account" xd-qa-type="link" xd-qa-name="click here">click here</InternalLink>
                    </div>
                )}
            </section>
            <div className="line"/>

            <section>
                <header>
                    <div className="title" xd-qa-type="label" xd-qa-name="Security Questions">Security Questions</div>
                    <button className="edit" onClick={securityQuestionModal.show} xd-qa-type="link" xd-qa-name="Edit Security Questions">Edit</button>
                </header>
            </section>
        </div>
    ))
    .run()
);

const checkGenericUserExists = ({next: rootNext, userLevels}:{
    next: Link<JSX.Element, boolean>,
    userLevels: Types.Xpresso.Loaders.ContextNameMap['userLevels'],
}) => (
    makeChain<JSX.Element>()
    .then(...consumeContext("company"))
    .then(...consumeContext("session"))
    .then(({company, session}) => rootNext(
        userLevels?.userLevel === COMPANY_LEVEL
        ? company?.idUser !== null
        : session?.data?.branch?.idUser !== null
    ))
    .run()
);

